import dayjs from "dayjs";

export const FAQ_LINK = "https://faq-travel-hsbc.hopper.com/";

export const getFaqLink = (language: string): string => {
  if (language === "ar") {
    return "https://faq-travel-hsbc.hopper.com/lang/ar/";
  }
  return FAQ_LINK;
};

export const isProductionEnv = () => {
  return [
    "hsbc-sg.hopper.com",
    "travel.hsbc.com.sg",
    "hsbc-sg.portal.hopper.com",
    "hsbc-in.portal.hopper.com",
    "hsbc-uae.portal.hopper.com",
    "hsbc-qa.portal.hopper.com",
    "travel.hsbc.co.in",
    "travel.hsbc.ae",
    "travel.hsbc.com.qa",
  ].includes(window.location.host);
};

export const isThirdPartyDomain = () => {
  return [
    "travel.hsbc.com.sg",
    "travel.hsbc.co.in",
    "travel.hsbc.ae",
    "travel.hsbc.com.qa",
    "travel-staging.hsbc.co.in",
    "travel-staging.hsbc.ae",
    "travel-staging.hsbc.qa",
  ].includes(window.location.host);
};

export const HSBC_OLD_POINTS_RATE = 400;

export const POINTS_RATE_EXPIRE_DATE = dayjs()
  .year(2025)
  .month(11)
  .date(31)
  .toDate();

export const MIN_DRIVING_AGE = 16;
